<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.repositories')}`">
              <div class="v-table">
                <TableServer type="repositories" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-repository')}`">
              <RepositoryForm v-if="spawnerAdminSchemas.forms['Repository']" />
            </b-tab>
            <b-tab
              v-if="repositoryId !== null && adminRepository.id > 0"
              :title="`${this.$i18n.t('JSON.repository')}#${repositoryId}`"
            >
              <RepositoryForm
                v-if="spawnerAdminSchemas.forms['Repository']"
                :repository="adminRepository"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    RepositoryForm: () => import('@/components/admin/spawner/modals/forms/RepositoryForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    repositoryId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      adminRepository: (state) => state.adminRepository.adminRepository,
    }),

    modalId() {
      return 'repository';
    },
  },

  watch: {
    repositoryId(newValue) {
      if (newValue !== null) {
        this.loadSpawnerAdminRepository();
      }
    },
  },

  methods: {
    ...mapActions(['getSpawnerAdminRepository']),

    async loadSpawnerAdminRepository() {
      try {
        await this.getSpawnerAdminRepository({
          params: {
            tid: this.repositoryId,
          },
        });

        // console.log('repository', this.repository);

        // success
        // console.log('success loading repository!');
      } catch (error) {
        // error
        // console.log('error loading repository!');
      }
    },

    onOpened() {
      if (this.repositoryId !== null) {
        this.loadSpawnerAdminRepository();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
